// Careers content — open roles + perks.
// PLACEHOLDER ROLES: edit the OPEN_ROLES array with the actual current openings.
// Each role must have a unique `id` (slug) — used by the application form.

export const CAREERS_INTRO = {
  overline: "Careers at Milestone",
  headline: ["Build the chemistry of", "tomorrow with us."],
  body:
    "For twenty-five years we've engineered specialty chemistry that quietly reaches over 50 countries — into snacks and edible oils, monomers and coatings, pharmaceuticals and personal care. If you'd like to design, prove, audit or scale molecules that touch the real world, keep reading.",
};

export const WORK_PILLARS = [
  {
    k: "Innovation",
    title: "Design molecules that matter.",
    body:
      "R&D at Milestone isn't a satellite lab; it's the engine. Chemists here design new products and cleaner routes, then walk them onto the plant floor at scale. If you've been waiting for a place that treats innovation as a habit — not a headline — this is it.",
  },
  {
    k: "Quality",
    title: "Rigour is a competitive advantage.",
    body:
      "We're actively hiring across the quality function — assurance, compliance and analysis. From HPLC, GC and Karl-Fischer benches to audit rooms and regulatory filings, your protocols become the reason global customers keep coming back.",
  },
  {
    k: "Reach",
    title: "Chemistry with a passport.",
    body:
      "Products from Dahej and Vadodara ship to 50+ countries — sitting inside snacks in Manila, resins in Rotterdam and oil fields in Texas. The work you do here won't stay local; it travels.",
  },
];

export const PERKS = [
  {
    k: "01",
    title: "Ownership, not hierarchy",
    body:
      "Flat organisation; every chemist, analyst, engineer and operator owns their batch, their data, their decisions.",
  },
  {
    k: "02",
    title: "A quality culture, not a department",
    body:
      "Every batch is our reputation. Chemists, QA analysts, compliance leads and operators share one obsession — clean, defensible data.",
  },
  {
    k: "03",
    title: "Continuous learning",
    body:
      "Cross-train across antioxidants, tocopherol distillation, specialty phenolics and instrumentation — we don't put people in boxes.",
  },
  {
    k: "04",
    title: "Built for the long game",
    body:
      "A 25-year-old family business with the patience to invest in people, processes, instrumentation and the planet.",
  },
];

export const OPEN_ROLES = [
  {
    id: "senior-rd-manager",
    title: "Senior R&D Manager",
    location: "Dahej, Gujarat",
    department: "R&D",
    type: "Full-time",
    experience: "10+ years",
    summary:
      "Lead new-molecule development and process-innovation roadmaps across fine and specialty chemicals. Ph.D. in Organic / Synthetic Chemistry with a strong track record in advanced organic synthesis and successful lab-to-plant scale-up.",
  },
  {
    id: "process-chemist",
    title: "Process Chemist",
    location: "Dahej, Gujarat",
    department: "R&D / Manufacturing",
    type: "Full-time",
    experience: "3–6 years",
    summary:
      "Own scale-up and process optimisation for specialty chemicals. M.Sc. / M.Tech. (Chem) with hands-on plant exposure.",
  },
  {
    id: "junior-rd-associate",
    title: "Junior R&D Associate",
    location: "Dahej, Gujarat",
    department: "R&D",
    type: "Full-time",
    experience: "1–3 years",
    summary:
      "Bench chemist working on new reactions and route-scouting studies alongside senior R&D. M.Sc. Organic Chemistry with hands-on experience in advanced organic synthesis, reaction monitoring (TLC, HPLC, NMR interpretation) and clear technical writing.",
  },
  {
    id: "lab-technician-rd",
    title: "Lab Technician — R&D",
    location: "Dahej, Gujarat",
    department: "R&D",
    type: "Full-time",
    experience: "2–5 years",
    summary:
      "Hands-on execution partner for the R&D team and top management — running reactions, work-ups, distillations and lab-level unit processes safely and repeatably. Diploma / B.Sc. Chemistry with strong lab-bench proficiency; comfortable owning glassware, timing and yields.",
  },
  {
    id: "lab-technician-fm",
    title: "Lab Technician — Applications",
    location: "Dahej, Gujarat",
    department: "R&D",
    type: "Full-time",
    experience: "2–5 years",
    summary:
      "Hands-on execution partner for the R&D team and top management — running formulations, wet lab analyses, work-ups, distillations and lab-level unit processes safely and repeatably. Diploma / B.Sc. Chemistry with strong lab-bench proficiency; comfortable owning glassware, timing and yields.",
  },
  {
    id: "qc-analyst",
    title: "QC Chemist — Analysis",
    location: "Dahej, Gujarat",
    department: "Quality · Analysis",
    type: "Full-time",
    experience: "2–5 years",
    summary:
      "Run HPLC, GC and Karl-Fischer protocols across incoming, in-process and finished-goods samples. Maintain CoAs and traceability. B.Sc. Chemistry minimum with analytical-instrument experience.",
  },
  {
    id: "qa-executive",
    title: "QA Executive — Assurance & Compliance",
    location: "Dahej, Gujarat",
    department: "Quality · Assurance & Compliance",
    type: "Full-time",
    experience: "4–7 years",
    summary:
      "Own batch-release systems, audits, complaint investigations and regulatory documentation across FSSC 22000, FAMIQS, ISO 9001, HALAL, KOSHER, FSSAI and REACH. Detail-obsessed chemists with QMS experience preferred.",
  },
  {
    id: "production-supervisor",
    title: "Production Supervisor",
    location: "Vadodara, Gujarat",
    department: "Operations",
    type: "Full-time",
    experience: "5–8 years",
    summary:
      "Lead shift operations across multiple unit processes. Diploma / B.E. Chemical Engineering with team-leadership experience.",
  },
];

export const HIRING_NOTE = {
  title: "Don't see your role?",
  body:
    "We're always interested in hearing from process chemists, chemical engineers, QA / QC / regulatory specialists and B2B commercial talent. Send us a general application and we'll keep you in mind.",
};
